import type { Data } from '@repo/strapi'
import CkEditorCSRRenderer from '@/components/elementary/CkEditorRenderer/CkEditorCSRRenderer'
import { Tooltip } from '@/components/elementary/Tooltip'
import { Done } from '@/components/icons/Done'
import { Info } from '@/components/icons/Info'
import { cn } from '@/lib/styles'
import styles from './FeatureCell.module.css'

// biome-ignore lint/complexity/noExcessiveCognitiveComplexity: No complexity - easy to follow
export function FeatureCell({
	featureItem,
	yearly,
	defaultChecked,
}: {
	featureItem?: Data.Component<'shared.pricing-feature'> | null
	yearly?: boolean
	defaultChecked?: boolean
}) {
	if (!featureItem) {
		return defaultChecked ? (
			<Done aria-hidden="true" className="size-5 text-brand-salmon shrink-0" />
		) : null
	}

	const text = yearly ? featureItem.textYearly : featureItem.textMonthly
	const tooltipLabel = yearly ? featureItem.tooltipLabelYearly : featureItem.tooltipLabelMonthly
	const tooltipContent = yearly
		? featureItem.tooltipContentYearly
		: featureItem.tooltipContentMonthly

	if (featureItem.isChecked) {
		return <Done aria-hidden="true" className="size-5 text-brand-salmon shrink-0" />
	}

	if (text || tooltipLabel) {
		return (
			<div className="grid place-items-center text-center">
				{text ? (
					<CkEditorCSRRenderer
						htmlContent={text}
						className={cn(styles['table-cell-content'], 'xl:whitespace-nowrap')}
						defaultTypography="bodyMedium"
					/>
				) : null}

				<div className="flex items-center gap-2 min-w-0">
					{tooltipLabel ? (
						<CkEditorCSRRenderer
							htmlContent={tooltipLabel}
							className={cn(
								styles['table-cell-content'],
								'xl:whitespace-nowrap',
								text ? 'lok-text-body-small' : 'lok-text-body-medium',
							)}
							defaultTypography={text ? 'bodySmall' : 'bodyMedium'}
						/>
					) : null}

					{tooltipContent ? (
						<Tooltip content={tooltipContent}>
							<span>
								<Info className="text-neutral-light-400 size-4 shrink-0" />
							</span>
						</Tooltip>
					) : null}
				</div>
			</div>
		)
	}

	return null
}
